@if (!loadComplete()) {
  <is-wait-message [loadComplete]="loadComplete()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0">
  </is-wait-message>
}

@if (paymentFormReview) {
  <form class="fluid-container" [formGroup]="paymentFormReview.group" class="manage-payment-form-container">
    <div class="bolt-container">
      <bolt-progress-bar appFocusOnInit arialabel="Update automatic payment progress value is 60%" class="progress-bar-container to-container" value="60"></bolt-progress-bar>
      <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Update automatic payment information: review & submit
      </h1>
      <div class="bolt-row">
        <div class="bolt-col-12">
          <section id="payment-details" class="bolt-space-bottom-lg">
            <app-payment-sub-header>Payment details</app-payment-sub-header>
            <fieldset class="section-content">
              <legend class="fields-only"></legend>
              @for (field of paymentDetailsReviewFields; track field) {
                @if (!field.cardType) {
                  <app-recap-form-field [field]="field" class="bolt-space-bottom-xl">
                  </app-recap-form-field>
                }
                @if (field.cardType) {
                  <app-bankcard-recap-form-field [field]="field" class="bolt-space-bottom-xl">
                  </app-bankcard-recap-form-field>
                }
              }
            </fieldset>
          </section>
          @if (emailAddress) {
            <section class="bolt-space-bottom-lg">
              <app-payment-sub-header>
                Contact information
              </app-payment-sub-header>
              <app-email-form-control formGroupName="emailAddressGroup">
              </app-email-form-control>
            </section>
          }
          <section id="auto-pay-authorization-section" class="bolt-space-bottom-2xl">
            <app-payment-sub-header>Authorization agreement</app-payment-sub-header>
            @if (canShowWaitSpinner()) {
              <bolt-waiting-indicator class="bolt-space-bottom-lg"></bolt-waiting-indicator>
            }
            @if (canDisplayAuthorizationAgreement) {
              <div>
                <span>Check that you've read and agree to the terms of the agreement.</span>
                <div class="ez-pay-section-content">
                  <app-ez-pay-authorization formGroupName="ezPayAuthGroup"></app-ez-pay-authorization>
                </div>
              </div>
            }
            @if (!canDisplayAuthorizationAgreement && generateAutoPayAuthorizationErrorContent) {
              <div>
                <bolt-notification id="generate-auto-pay-authorization-error" class="to-container bolt-space-bottom-2xl" type="error">
                  <is-interpolate [text]="generateAutoPayAuthorizationErrorContent"></is-interpolate>
                </bolt-notification>
              </div>
            }
          </section>
        </div>
      </div>
    </div>
    <bolt-button-bar>
      <is-button id="cancel-button" (click)="navigateToPaymentPreferences()" slot="cancel">Cancel</is-button>
      <is-button id="back-button" (click)="navigateToEditAutomaticPayments()" slot="back">Back</is-button>
      <is-button [isDisabled]="disableSubmit() || canShowWaitSpinner()" id="submit-button" slot="forward" (click)="onSubmitEditAutomaticPayment()" [type]="solid" class="jm-visible" [class]="'jm-visible'">Submit</is-button>
    </bolt-button-bar>
  </form>
}